export function fmtListAsCsv(items) {
  const array_items=Array.isArray(items)?items:JSON.parse("[" + items + "]");
  return array_items.join(", ");
}
